var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(
      [
        'UserRegister',
        'Userlogin',
        'RegisterForm',
        'NewClubForm',
        'ResetPassword',
        'ChangePasswordWithToken'
      ].indexOf(_vm.$route.name) == -1
    )?_c('Header',{key:("h-" + (_vm.$route.path))}):_vm._e(),_c('router-view',{key:_vm.$route.path}),(
      [
        'UserRegister',
        'Userlogin',
        'RegisterForm',
        'NewClubForm',
        'ResetPassword',
        'page_not_found',
        'forbidden',
        'internal-server-error',
        'ChangePasswordWithToken'
      ].indexOf(_vm.$route.name) == -1
    )?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }